var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"a-checklist"},_vm._l((_vm.items),function(item){return _c('li',{key:item.text,staticClass:"a-checklist-item"},[_vm._v(_vm._s(_vm.$t(item.text)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }